import React, { useState, useEffect } from "react";

import { colors } from "./../../../../Util/colors";

const NumberInput = ({ initial, docs, setDocs, doc, input_key }) => {
  const [input, setInput] = useState(initial);

  const [borderColor, setBorderColor] = useState("bright_grey");

  function handleChange(txt) {
    setInput(txt);

    let theDoc = { ...doc };

    theDoc[input_key] = txt;

    let newDocs = [];
    let added = false;

    for (let i = 0; i < docs.length; i++) {
      if (docs[i]._id === doc._id) {
        newDocs.push(theDoc);
        added = true;
        continue;
      }
      newDocs.push(docs[i]);
    }

    if (added) {
      setDocs(newDocs);
      return;
    }

    setDocs([...newDocs, theDoc]);
  }

  return (
    <input
      className=" border-2 rounded-lg w-full py-2 px-8 placeholder-cadet_grey"
      onFocus={() => setBorderColor("primary")}
      style={{
        borderColor: colors[borderColor],
      }}
      type={"number"}
      value={input}
      onChange={(e) => handleChange(e.target.value)}
    />
  );
};

export default NumberInput;
